export default __webpack_public_path__ + "static/media/ashe-bg.71583a31.jpg";